<template lang="pug">
.container-restricao
        div.card-restricao(
            v-if='restricoes.length > 0',
            :class='restricoes[index].inibido !== "undefined" && restricoes[index].inibido ? "camada-inibida" : ""',
            v-for='(restricao, index) in listaRestricoes'
        )
            slot(name='botaoInibir', :restricao='restricoes[index]')
            .card-restricao
                .container-restricao-acoes(
                    v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
                )
                    div
                        BaseButton(
                            size='small',
                            icon='mdi mdi-crosshairs-gps',
                            @click='aplicarZoomRestricao(index)'
                        )
                slot(name='selecionarRestricao', :restricao='restricoes[index]')
                p
                    b Número do auto de infração:
                    |
                    | {{ restricao.auto }}
                    br
                    b Nome do autuado:
                    |
                    | {{ restricao.nome_razao_social_do_autuado }}
                    br
                    b CPF/CNPJ do autuado:
                    |
                    | {{ restricao.cpf_cnpj }}
                    br
                    b Data da autuação:
                    |
                    | {{ restricao.data_autuacao }}
                    br
                    b Município da autuação:
                    |
                    | {{ restricao.municipio_da_autuacao }}
                    br
                    b Enquadramento legal:
                    |
                    | {{ restricao.enquadramento_legal }}
                    br
                    b Tipo de infração:
                    |
                    | {{ restricao.tipo_infracao }}
                    br
                    b Descrição do TAD:
                    |
                    | {{ restricao.descricao_da_apreensao_embargo }}
                    br
                    b Situação do embargo:
                    |
                    | {{ restricao.situacao_do_embargo }}
                   
                    Criticidade(
                        v-if='restricao.nivelAlerta'
                        :restricao='restricao'
                    )
</template>
    
    <script>
    import formatters from '@/utils/formatters';
    import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
    import BaseButton from '@/components/vegaComponents/BaseButton.vue';
    
    export default {
        name: 'area-embargada-piaui',
    
        emits: ['highlightGeometry'],
    
        components: {
            Criticidade,
            BaseButton
        },
    
        data() {
            return {};
        },
    
        props: {
            restricoes: {
                type: Array,
                required: true
            },
            geometria: {
                type: Array,
                required: false,
                default: null
            },
            habilitarZoomRestricao: {
                type: Boolean,
                required: false,
                default: false
            }
        },
    
        computed: {
            listaRestricoes: function () {
                return this.restricoes.map(value => {
                    if (value.properties) {
                        return {
                            ...value.properties
                        };
                    }
                    return value;
                });
            }
        },
    
        methods: {
            aplicarZoomRestricao(index) {
                let geometriaQueNaoEstavaDentroDasRestricoes = null;
                if (this.geometria) {
                    geometriaQueNaoEstavaDentroDasRestricoes =
                        this.geometria[index];
                }
                this.$emit(
                    'aplicar-zoom-restricao',
                    this.restricoes[index],
                    geometriaQueNaoEstavaDentroDasRestricoes
                );
            },
            formatNumber(number) {
                if (!number) return '-';
                return formatters.maxFormatNumber(number, 2);
            },
    
            formatNumberPercent(number) {
                if (!number) return '-';
                return formatters.maxFormatNumber(number, 2) + '%';
            }
        }
    };
    </script>
    
    <style lang="scss" scoped>
        .card-restricao {
            margin-top: 3%;
        }
    </style>
